(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.onScrollHandler = this.onScroll.bind(this);
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.section =
        this.closest('.section-header') ||
        document.querySelector('.section-header');

      if (!this.section) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 989px)')
        .addEventListener('change', this.setHeaderHeightHandler);

      if (this.headerIsAlwaysSticky) {
        this.section.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.addEventListener(
        'preventHeaderReveal',
        () => {
          this.preventReveal = true;
        }
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

      window
        .matchMedia('(max-width: 989px)')
        .removeEventListener(
          'change',
          this.setHeaderHeightHandler
        );
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.section.offsetHeight}px`
      );
    }

    createObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        }
      );

      observer.observe(this.section);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.section.classList.add(
          'scrolled-past-header'
        );

        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(
            this.hide.bind(this)
          );
        }
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.section.classList.add(
          'scrolled-past-header'
        );

        if (
          !this.preventReveal &&
          !this.headerIsAlwaysSticky
        ) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        }
      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.section.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.section.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeOpenHeaderElements();
    }

    reveal() {
      this.section.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.section.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.section.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeOpenHeaderElements() {
      this.querySelectorAll('details[open]').forEach(
        (detailsElement) => {
          detailsElement.removeAttribute('open');
        }
      );
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();
})();
